import {useMemo, useRef, useState} from 'react'
import {IconX} from '@tabler/icons-react'
import {fullName, lifespan, nameMatches, searchWords} from './api/tree'
import type {TreeIndex} from './api/types'

interface Props {
  ix: TreeIndex
  value: string | null
  onChange: (h: string | null) => void
  /** кого нельзя выбрать: сам человек и уже занятые роли */
  exclude?: (string | null)[]
  placeholder?: string
}

export default function PersonPicker({ix, value, onChange, exclude = [], placeholder = 'не указан'}: Props) {
  const [q, setQ] = useState('')
  const [open, setOpen] = useState(false)
  const box = useRef<HTMLDivElement>(null)

  const banned = useMemo(() => new Set(exclude.filter((x): x is string => !!x)), [exclude])

  const hits = useMemo(() => {
    const words = searchWords(q)
    if (q.trim().length < 2) return []
    return [...ix.people.values()]
      .filter(p => !banned.has(p.handle) && nameMatches(p, words))
      .slice(0, 7)
  }, [ix, q, banned])

  const chosen = value ? ix.people.get(value) : null

  if (chosen) {
    return (
      <div className="picked">
        <span className="pn">{fullName(chosen)}</span>
        <span className="pd">{lifespan(chosen)}</span>
        <button type="button" className="icobtn" title="Убрать" onClick={() => onChange(null)}>
          <IconX size={15} stroke={1.8} />
        </button>
      </div>
    )
  }

  return (
    <div className="picker" ref={box}>
      <input
        value={q}
        onChange={e => { setQ(e.target.value); setOpen(true) }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
      />
      {open && hits.length > 0 && (
        <div className="sresults">
          {hits.map(p => (
            <div key={p.handle} onMouseDown={() => { onChange(p.handle); setQ(''); setOpen(false) }}>
              {fullName(p)}
              <span>{lifespan(p)}</span>
            </div>
          ))}
        </div>
      )}
      {open && q.trim().length >= 2 && !hits.length && (
        <div className="sresults"><div className="muted">Никого не нашлось</div></div>
      )}
    </div>
  )
}
